import React, { Component } from "react";
import "./../css/master.css";
import "./../css/maintainDesignColor.css";
import Header from "./../js/header.js";
import axiosInstance from "../api/csAxios";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactImageMagnify from "react-image-magnify";
const { IMG_TYPES } = require("./imgType");
var httpURL = "";
var queryString = require("querystring");
var lstDesignColor = [];
var designIdCol = "td:eq(0)";
var designColorCol = "td:eq(1)";
var designImageCol = "td:eq(2)";
var updatedOnCol = "td:eq(3)";
var lstMachineType = [];

class MaintainDesignColor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      designColor: [],
      
      machine: "",
      flg: true,
      width: "97.5%",
      loader: "none",
      opacity: 1,
      src: require("./../images/blank.png"),
    };
  }

  componentDidMount = () => {
    this.setState({ loader: "block", opacity: 0.5 });

    axiosInstance
      .get(httpURL + "/a/mst/dsn/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            designColor: response.data.lstDesigns,
          });
          lstDesignColor = this.state.designColor;
          this.setDesignColorTable();
        } else {
          toast.error(response.data.SvcMsg);
        }
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    axiosInstance
      .get(httpURL + "/a/mst/mty/list", {
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            machine: response.data.lstMachineType,
          });
          lstMachineType = this.state.machine;
          for (var i = 0; i < lstMachineType.length; i++) {
            lstMachineType[i].selected = 0;
          }
          this.setMachineTable(lstMachineType);
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });

    this.handleResize();
    window.addEventListener("load", this.handleResize);
    window.addEventListener("resize", this.handleResize);
  };

  handleResize = () => {
    var width = $(".tableLayout1").parent().width() - 18;
    this.setState({ width: width });
  };

  setDesignColorTable = () => {
    $("#designColorTableBody tr").remove();
    var table = document.getElementById("designColorTable");
    var tbody = document.getElementById("designColorTableBody");
    var filterDesignColor = $("#designColor").val().toLowerCase();

    for (var i = 0; i < lstDesignColor.length; i++) {
      var id = lstDesignColor[i].designId;
      var designColor = lstDesignColor[i].designNoColor;
      var designImage = lstDesignColor[i].imgPath;
      var updatedOn = lstDesignColor[i].updatedOn;

      var row = document.createElement("tr");
      row.id = id;

      row.onclick = (e) => {
        $($(e.target).closest("tr"))
          .addClass("selected")
          .siblings()
          .removeClass("selected");
        console.log("row clicked");
        this.setDesignColorForm(
          $("#designColorTableBody tr.selected").find(designIdCol).text()
        );
        this.setState({ flg: false });
      };

      if (designColor.toLowerCase().indexOf(filterDesignColor) === -1) continue;

      this.addTD(row, id, "no-display");
      this.addTD(row, designColor, "");
      this.addTDImage(row, designImage, "text-center");
      this.addTD(row, updatedOn, "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  setMachineTable = (lstMachine) => {
    $("#machineTableBody tr").remove();
    var table = document.getElementById("machineTable");
    var tbody = document.getElementById("machineTableBody");

    for (var i = 0; i < lstMachine.length; i++) {
      var machineTypeId = lstMachine[i].machineTypeId;
      var machineType = lstMachine[i].machineType;
      var selected = lstMachine[i].selected;

      var row = document.createElement("tr");
      row.id = machineTypeId;

      this.addTD(row, machineTypeId, "no-display");
      this.addTD(row, machineType, "");
      this.addTDCbx(row, "cbx" + machineTypeId, selected, "text-center");

      tbody.append(row);
    }
    table.append(tbody);
  };

  addTD(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var text = document.createTextNode(val);
    cell.append(text);
    row.append(cell);
  }

  addTDImage(row, val, classname) {
    var date = new Date();
    var cell = document.createElement("td");
    cell.className = classname;
    var lazyload = document.createElement("LazyLoad");
    // lazyload.offset = 100;
    var img = document.createElement("img");
    img.style.width = "20px";
    img.style.height = "20px";
    if (val == "") {
      img.src = require("../images/logo.png");
    } else if (val != null) {
      img.src =
        window.httpURL +
        "/a/mst/dsn/getImage?img=" +
        val +
        "&imgType=" +
        IMG_TYPES.THUMB;
    } else {
      img.src = require("../images/logo.png");
    }
    lazyload.append(img);
    cell.append(lazyload);

    row.append(cell);
  }

  addTDCbx(row, id, flg, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var cbx = document.createElement("input");
    cbx.type = "checkbox";
    cbx.id = id;
    if (flg == 1) {
      $(cbx).prop("checked", true);
    } else {
      $(cbx).prop("checked", false);
    }
    cell.append(cbx);
    row.append(cell);
  }

  setDesignColorForm = (id) => {
    console.log("setDesignColorForm() called");
    console.log(IMG_TYPES);
    var date = new Date();
    var designColorData = this.getdesignColorData(id);
    $("#machineTableBody tr").find(
      $("input[type=checkbox]").attr("checked", false)
    );
    console.log(designColorData);
    if (designColorData !== -1) {
      $("#inp_designColor").val(designColorData.designNoColor);
      $("#inp_notes").val(designColorData.notes);
      console.log(designColorData.imgPath);
      if (designColorData.imgPath == "") {
        this.setState({ src: null });
      } else if (designColorData.imgPath != null) {
        console.log(
          window.httpURL +
            "/a/mst/dsn/getImage?img=" +
            designColorData.imgPath +
            "&imgType=" +
            IMG_TYPES.DSN
        );
        this.setState({
          src:
            window.httpURL +
            "/a/mst/dsn/getImage?img=" +
            designColorData.imgPath +
            "&imgType=" +
            IMG_TYPES.DSN,
        });
      } else {
        this.setState({ src: null });
      }
    }

    axiosInstance
      .get(httpURL + "/a/mst/dsn/listDesignMachineType", {
        params: {
          designId: id,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          var machineType = response.data.lstMachines;
          this.setMachineTable(machineType);
        } else {
          toast.error(response.data.SvcMsg);
        }
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  getdesignColorData(id) {
    for (var i = 0; i < lstDesignColor.length; i++) {
      if (id == lstDesignColor[i].designId) {
        return lstDesignColor[i];
      }
    }
    return -1;
  }

  addDesignColorReady = () => {
    $("#designColorAddForm").trigger("reset");
    this.setMachineTable(lstMachineType);
    this.setState({ flg: true, src: require("./../images/blank.png") });
  };

  maintainDesignColor = () => {
    if (this.state.flg) {
      this.addDesignColor();
    } else {
      this.editDesignColor();
    }
  };

  addDesignColor = () => {
    var design = {};
    var designColor = $("#inp_designColor").val().toUpperCase();
    var notes = $("#inp_notes").val();
    var lstMachine = [];
    var ext = "";
    $("#machineTableBody tr").each(function (index, value) {
      if ($(this).find($("input[type=checkbox]")).prop("checked") == true) {
        var id = $(this).find("td:eq(0)").text();
        lstMachine.push(id);
      }
    });
    if (designColor == "") {
      toast.warning("Please fill design color");
      document.getElementById("inp_designColor").focus();
      return false;
    }

    if (notes == "") {
      toast.warning("Please fill Notes");
      document.getElementById("inp_notes").focus();
      return false;
    }

    if (lstMachine.length == 0) {
      toast.warning("Please select atleast one machine");
      return false;
    }

    if (document.getElementById("uploadImageFile").value != "") {
      ext = $("#uploadImageFile").val().split(".").pop().toLowerCase(); //input type file value

      if ($.inArray(ext, ["png", "jpg", "jpeg"]) === -1) {
        toast.warning("Invalid File Uploaded. Please, Upload Again!");
        return false;
      } else {
        var file = document.getElementById("uploadImageFile"); //input type file value
        var file_data = file.files[0]; //No need Extra
        var file_data = $("#uploadImageFile").prop("files")[0]; //input type file value
        this.setState({ src: URL.createObjectURL(file_data) });
      }
    } else {
      toast.warning("Please select design image");
      return false;
    }

    var file = document.getElementById("uploadImageFile"); //input type file value
    var file_data = file.files[0]; //No need Extra
    var file_data = $("#uploadImageFile").prop("files")[0]; //input type file value
    var form_data = new FormData();
    design = {
      designId: 0,
      designNoColor: designColor,
      notes: notes,
      lstMachineType: lstMachine,
    };
    form_data.append("design", JSON.stringify(design));
    form_data.append("img", file_data == undefined ? null : file_data);
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance({
      url: httpURL + "/a/mst/dsn/save",
      method: "POST",
      data: form_data,
      config: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          $("#uploadImageFile").val("");
          var imageName =
            file_data == undefined ? "" : response.data.designId + "." + ext;
          design = {
            designId: response.data.designId,
            designNoColor: designColor,
            notes: notes,
            updatedOn: response.data.updatedOn,
            imgPath: imageName,
          };
          lstDesignColor.unshift(design);
          this.setDesignColorTable();
          this.highlightRow("designColorTableBody", response.data.designId);
          this.setState({ flg: false });
          // this.setThumbNails();
        } else {
          toast.error(response.data.SvcMsg);
          $("#uploadImageFile").val("");
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service Failed: " + e);
      });
  };
  setThumbNails = () => {
    for (var i = 0; i < lstDesignColor.length; i++) {
      var designImage = lstDesignColor[i].imgPath;
      var id = lstDesignColor[i].designId;
      $("#" + id)
        .find("td:eq(2)")
        .closest("img")
        .attr("src", designImage);
    }
  };
  editDesignColor = () => {
    var design = {};
    var designId = $("#designColorTableBody tr.selected")
      .find(designIdCol)
      .text();
    var notes = $("#inp_notes").val();
    var designColor = $("#inp_designColor").val().toUpperCase();
    var imageName = "";
    var lstMachine = [];
    $("#machineTableBody tr").each(function (index, value) {
      if ($(this).find($("input[type=checkbox]")).prop("checked") == true) {
        var id = $(this).find("td:eq(0)").text();
        lstMachine.push(id);
      }
    });
    if (designId == "") {
      toast.warning("Please select row");
      return false;
    }

    if (designColor == "") {
      toast.warning("Please fill design color");
      document.getElementById("inp_designColor").focus();
      return false;
    }

    if (notes == "") {
      toast.warning("Please fill Notes");
      document.getElementById("inp_notes").focus();
      return false;
    }

    if (lstMachine.length == 0) {
      toast.warning("Please select atleast one machine");
      return false;
    }

    if (document.getElementById("uploadImageFile").value != "") {
      var ext = $("#uploadImageFile").val().split(".").pop().toLowerCase(); //input type file value

      if ($.inArray(ext, ["png", "jpg", "jpeg"]) === -1) {
        toast.warning("Invalid File Uploaded. Please, Upload Again!");
        return false;
      } else {
        var file = document.getElementById("uploadImageFile"); //input type file value
        var file_data = file.files[0]; //No need Extra
        var file_data = $("#uploadImageFile").prop("files")[0]; //input type file value
        this.setState({ src: URL.createObjectURL(file_data) });
      }
    }

    design = {
      designId: designId,
      designNoColor: designColor,
      notes: notes,
      lstMachineType: lstMachine,
    };
    var form_data = new FormData();
    var file = document.getElementById("uploadImageFile"); //input type file value
    var file_data = file.files[0]; //No need Extra
    var file_data = $("#uploadImageFile").prop("files")[0];
    form_data.append("design", JSON.stringify(design));
    form_data.append("img", file_data == undefined ? null : file_data);
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance({
      url: httpURL + "/a/mst/dsn/save",
      method: "POST",
      data: form_data,
      config: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          $("#uploadImageFile").val("");
          var designColorIdx = this.getIdxDesignColor(designId);
          var imageName =
            file_data == undefined
              ? lstDesignColor[designColorIdx].imgPath
              : designId + "." + ext;
          design = {
            designId: designId,
            designNoColor: designColor,
            notes: notes,
            updatedOn: response.data.updatedOn,
            imgPath: imageName,
          };
          lstDesignColor.splice(designColorIdx, 1);
          lstDesignColor.unshift(design);
          this.setDesignColorForm(designId);
          this.setDesignColorTable();
          this.highlightRow("designColorTableBody", designId);
        } else {
          toast.error(response.data.SvcMsg);
          $("#uploadImageFile").val("");
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service Failed: " + e);
      });
  };

  getIdxDesignColor(Id) {
    for (var i = 0; i < lstDesignColor.length; i++) {
      if (lstDesignColor[i].designId == Id) {
        return i;
      }
    }
    return -1;
  }

  highlightRow(table, id) {
    $("#" + table + " tr").each(function () {
      var designId = $(this).find(designIdCol).text();
      if (designId == id) {
        $(this).addClass("selected").siblings().removeClass("selected");
      }
    });
  }

  triggerUploadImage = () => {
    $("#uploadImageFile").trigger("click");
  };

  triggerUploadDesign = () => {
    $("#uploadDesignFile").trigger("click");
  };

  uploadDesignImage = () => {
    if (document.getElementById("uploadImageFile").value != "") {
      var ext = $("#uploadImageFile").val().split(".").pop().toLowerCase(); //input type file value

      if ($.inArray(ext, ["png", "jpg", "jpeg"]) === -1) {
        toast.warning("ext: " + ext);
        toast.warning("Invalid File Uploaded. Please, Upload Again!");
      } else {
        var file = document.getElementById("uploadImageFile"); //input type file value
        var file_data = file.files[0]; //No need Extra
        var file_data = $("#uploadImageFile").prop("files")[0]; //input type file value
        this.setState({ src: URL.createObjectURL(file_data) });
      }
    }
  };

  /*uploadDesignImage =()=>{
		if (document.getElementById("uploadImageFile").value != "") {
			var ext = $('#uploadImageFile').val().split('.').pop().toLowerCase();  	//input type file value
			
			if ($.inArray(ext, ['png','jpg', 'jpeg']) === -1 ) {
				toast.warning("ext: "+ext);
				toast.warning('Invalid File Uploaded. Please, Upload Again!');
			}
			else{
			  var designModel = {};
			  $('#designColorImageDiv').empty();
			  var designId 		= $('#designColorTableBody tr.selected').find(designIdCol).text();
			  var designColor 	= $('#designColorTableBody tr.selected').find(designColorCol).text();
				
			  if(designId == ''){
				  toast.warning('Please select row');
				  return false;
			  }
			  
			  designModel.designId 		= designId;
			  designModel.designColor 	= designColor;
			  designModel.imageName 	= designId+'.'+ext;
			  var file 		= document.getElementById("uploadImageFile");		//input type file value
			  var file_data = file.files[0];									//No need Extra
			  var file_data = $("#uploadImageFile").prop("files")[0];			//input type file value
			  var form_data = new FormData();
			  form_data.append("designId", designId);
			  form_data.append("file", file_data);
			  var imageDiv = document.getElementById('designColorImageDiv');
			  var img = document.createElement('img');
				  img.style.width = '100%';
				  img.style.height = '100%';
				  img.src = URL.createObjectURL(file_data);
				  imageDiv.append(img);
			  
			  //csAxios({
				url: httpURL+"/a/m/upload_design_image",
				method: "POST",
				data:form_data,
				config:{
					headers:{
						'Content-Type':'multipart/form-data'
					}
				} ,
				withCredentials: true,
			  }).then((response)=>{
				if(response.data.SvcStatus === "Success" ){
					$('#uploadImageFile').val('');
					toast.success(response.data.SvcMsg);
					var designIndex = this.getIdxDesignColor(designId);
					lstDesignColor.splice(designIndex,1,designModel);
					this.setDesignColorTable();
					this.highlightRow('designColorTableBody', designId);
				}
				else{
					toast.error(response.data.SvcMsg);
					$('#uploadImageFile').val('');
				}
			  }).catch((e)=> {
				toast.error("Service Failed: " + e);
			  });
			}
		}
	}*/

  uploadDesignColor = () => {
    if (document.getElementById("uploadDesignFile").value != "") {
      var ext = $("#uploadDesignFile").val().split(".").pop().toLowerCase(); //input type file value

      if ($.inArray(ext, ["xls", "xlsx"]) === -1) {
        toast.warning("ext: " + ext);
        toast.warning("Invalid File Uploaded. Please, Upload Again!");
      } else {
        var file = document.getElementById("uploadDesignFile"); //input type file value
        var file_data = file.files[0]; //No need Extra
        var file_data = $("#uploadDesignFile").prop("files")[0]; //input type file value
        var form_data = new FormData();
        form_data.append("file", file_data);
        this.setState({ loader: "block", opacity: 0.5 });
        axiosInstance({
          url: httpURL + "/a/m/upload_design_color",
          method: "POST",
          data: form_data,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
          withCredentials: true,
        })
          .then((response) => {
            if (response.data.SvcStatus === "Success") {
              $("#uploadDesignFile").val("");
              toast.success(response.data.SvcMsg);
              this.componentDidMount();
            } else {
              toast.error(response.data.SvcMsg);
              $("#uploadDesignFile").val("");
            }
            this.setState({ loader: "none", opacity: 1 });
          })
          .catch((e) => {
            toast.error("Service Failed: " + e);
          });
      }
    }
  };

  render() {
    httpURL = window.httpURL;
    return (
      <div style={{ height: "100%" }}>
        <Header />
        <ToastContainer autoClose={2000} hideProgressBar />
        <div
          style={{
            position: "fixed",
            width: 100,
            height: 100,
            marginLeft: -50,
            marginTop: -50,
            left: "50%",
            top: "50%",
            display: this.state.loader,
          }}
        >
          <img src={require("../images/loader.gif")} alt="Loader..." />
        </div>
        <div className="main" style={{ opacity: this.state.opacity }}>
          <div className="container-fluid">
            <div className="col-sm-10 col-centered">
              <div
                className="col-sm-12 padding-remove"
                style={{ marginBottom: 10 }}
              >
                <input
                  type="file"
                  onChange={this.uploadDesignColor}
                  id="uploadDesignFile"
                  style={{ display: "none" }}
                />
                <button
                  style={{ marginRight: 20 }}
                  type="button"
                  className="btn btn-warning pull-right"
                  onClick={this.triggerUploadDesign}
                  id="uploadDesign"
                >
                  Upload Design Color
                </button>
              </div>
              <div className="col-sm-4 col-xs-11 padding-remove">
                <table
                  className="tableLayout1"
                  style={{ width: this.state.width }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 50, display: "none" }}>Design Id</th>
                      <th style={{ width: 100 }}>
                        <input
                          onChange={this.setDesignColorTable}
                          type="text"
                          className="form-control inp-search"
                          id="designColor"
                          placeholder="Design Color"
                        />
                      </th>
                      <th style={{ width: 50 }}>Image</th>
                      <th style={{ width: 100 }}>Updated On</th>
                    </tr>
                  </thead>
                </table>
                <div className="designColorTableDiv col-sm-12 col-xs-11 padding-remove">
                  <table id="designColorTable" className="tableLayout">
                    <colgroup>
                      <col width="100" />
                      <col width="50" />
                      <col width="100" />
                    </colgroup>
                    <tbody id="designColorTableBody"></tbody>
                  </table>
                </div>
              </div>
              <div className="col-sm-1 col-xs-1">
                <span
                  id="addDesignColor"
                  title="Add Design Color"
                  onClick={this.addDesignColorReady}
                  className="addIcon glyphicon glyphicon-plus-sign"
                ></span>
              </div>
              <div className="col-sm-7 col-xs-12">
                <form id="designColorAddForm" className="form-horizontal">
                  <div className="row">
                    <div className="col-sm-8">
                      <div className="form-group">
                        <label className="control-label col-sm-4">
                          Design Color:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Design Color"
                            id="inp_designColor"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="control-label col-sm-4">
                          Notes:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8">
                          <textarea
                            style={{ resize: "none" }}
                            placeholder="Notes"
                            className="form-control rounded-0"
                            id="inp_notes"
                            rows="6"
                          ></textarea>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="control-label col-sm-4">
                          Machine Type:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8">
                          <div
                            className="col-sm-12 padding-remove"
                            style={{ height: 200, overflowY: "scroll" }}
                          >
                            <table id="machineTable" style={{ width: "100%" }}>
                              <thead>
                                <tr>
                                  <th style={{ width: 100, display: "none" }}>
                                    Machine Id
                                  </th>
                                  <th style={{ width: 100 }}>Machine Type</th>
                                  <th style={{ width: 50 }}>Select</th>
                                </tr>
                              </thead>
                              <tbody
                                id="machineTableBody"
                                style={{ fontSize: 12 }}
                              ></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div
                        className="col-sm-10 padding-remove"
                        onClick={this.triggerUploadImage}
                        id="designColorImageDiv"
                      >
                        <ReactImageMagnify
                          {...{
                            smallImage: {
                              alt: "Design Image",
                              src: this.state.src,
                              isFluidWidth: true,
                            },
                            largeImage: {
                              src: this.state.src,
                              width: 600,
                              height: 900,
                            },
                            enlargedImageContainerDimensions: {
                              width: 300,
                              height: 300,
                            },
                            enlargedImageContainerStyle: {
                              left: -10,
                              top: 160,
                            },
                          }}
                        />
                      </div>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="uploadImageFile"
                        onChange={this.uploadDesignImage}
                      />
                    </div>
                  </div>
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <div className="col-sm-12 text-center">
                      <button
                        type="button"
                        onClick={this.maintainDesignColor}
                        className="btn btn-warning"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MaintainDesignColor;
